import { Button } from "@jti/core-components/components/Button";
import type { MagentoStockStatus } from "@jti/magento-types";

import styles from "./ProductCta.module.scss";

const DEFAULT_UNAVAILABLE_STATUSES: MagentoStockStatus[] = ["OUT_OF_STOCK", "AVAILABLE_IN_STORES"];

type ProductCtaProps = {
  productCta: { label: string; url: string };
  isCommerceDisabled?: boolean;
  isProductDataLoading: boolean;
  stockStatus: MagentoStockStatus;
  unavailableStatuses?: MagentoStockStatus[];
};

export const ProductCta = ({
  productCta,
  isCommerceDisabled,
  isProductDataLoading,
  stockStatus,
  unavailableStatuses = DEFAULT_UNAVAILABLE_STATUSES,
}: ProductCtaProps) => {
  const isProductCtaConfigured = productCta.url && productCta.label;
  const isUnavailableOnline = !isProductDataLoading && unavailableStatuses.includes(stockStatus);
  const shouldDisplay = isProductCtaConfigured && (isCommerceDisabled || isUnavailableOnline);

  if (!shouldDisplay) return null;

  return (
    <Button href={productCta.url} nativeBehaviour className={styles.button}>
      {productCta.label}
    </Button>
  );
};
